<template>
  <div :class="['obj-major-info-content', 'automap-object', 'config-info', lowerCase(objectType)]">
    <el-row class="title-bar" type="flex" justify="space-between">
      <span class="title">구성 정보</span>
      <p style="padding-top: 10px; font-size: 13px; color: #999;" v-if="showEditBtn">
        <span style="cursor: pointer;">
          <i class="fas fa-edit" v-show="!editable" @click="onEditBtnClick"></i>
        </span>
        <span class="mr-r5" style="cursor: pointer;">
          <i class="fas fa-save" v-show="editable" @click="onSaveBtnClick"></i>
        </span>
        <span class="mr-r10" style="cursor: pointer;">
          <i class="fas fa-undo" v-show="editable" @click="onUndoBtnClick"></i>
        </span>
      </p>
    </el-row>
    <div class="config-info-content mr-b10">
      <el-form ref="configForm" class="list-info-single" :model="configInfoData" label-width="140px" :rules="configRules">
        <el-form-item class="list-item" v-for="config in configInfo" :key="config.key" :prop="config.key" :label="config.label">
          <w-text-form v-if="!isObj && (config.key !== 'deviceTypeName' && config.key !== 'deviceIp' && config.key !== 'deviceMac' && config.key !== 'interfaceMac')" :class="editable ? 'editable' : ''" :modifiable="editable" :target="configInfoData" :property="config.key">
          </w-text-form>
          <span v-else-if="!isObj && config.key === 'deviceTypeName'" class="h100 w100 item-select">
            <el-cascader v-if="editable" ref="objtypeCascader" v-model="objtype" :show-all-levels="false" :options="objtypeList" :props="props" @change="onObjtypeChange" popper-class="automap-objtype-cascader">
              <template slot-scope="{ node, data }">
                <span>{{ data.label }}</span>
              </template>
            </el-cascader>
            <span v-else> {{convertValue(configInfoData[config.key], config.key, isEmpty(config.formatter) ? '' : config.formatter)}} </span>
          </span>
          <!-- <span v-else-if="config.key === 'deviceIp'">
            {{ convertValue(configInfoData[config.key], config.key, isEmpty(config.formatter) ? '' : config.formatter) }}
          </span> -->
          <span v-else>
            {{ convertValue(configInfoData[config.key], config.key, isEmpty(config.formatter) ? '' : config.formatter) }}
          </span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import WAvailRateSlidingPopup from '@/views/performance/node/summary/components/AvailRateSlidingPopup';
import WTextForm from '@/components/formeditor/TextFormEditor';
import WSelectForm from '@/components/formeditor/SelectFormEditor';
import { RELATIONSHIP_INFO } from '@/constants/topologymap-major-info';
import { isEmpty, isNil, cloneDeep, filter, lowerCase } from 'lodash';
import { getDateToString } from '@/utils/date';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';

import MapAPI from '@/api/topologymap/common';
import msgUtil from '@/utils/message';
import { MapInfo } from '@/views/topologymap/js/maps';


export default {
  name: 'WAutomapObjectConfigInfoView',
  components: {
    WAvailRateSlidingPopup,
    WTextForm,
    WSelectForm,
  },
  props: {
    objectInfo: {
      type: Object,
      default: () => {},
    },
    isObj: {
      type: Boolean,
      default: false,
    },
    objectType: {
      type: String,
      default: 'DEVICE',
    },
  },
  data() {
    return {
      getValueAfterCheckEmpty,
      isEmpty,
      lowerCase,
      /**
       * 구성정보 표현 객체
       * @type {Object}
       */
      RELATIONSHIP_INFO,
      /**
       * 구성정보 데이터
       * @type {Object}
       */
      configInfoData: {
        deviceName: '',
        deviceIp: '',
        deviceMac: '',
        deviceTypeName: '',
        deviceCompanyName: '',
        deviveDesc: '',
      },
      originConfigInfoData: {},
      activeContent: 'CONNECT_DEVICE',
      editable: false,
      objtypeList: [],
      deviceTypeName: '',
      props: {
        value: 'itemId',
      },
      objtype: [],
      configRules: {
        deviceIp: [
          {
            pattern: '^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
            message: 'IPv4에 맞는 형식으로 입력해주세요.',
            trigger: 'blur',
          },
        ],
        deviceMac: [
          {
            pattern: '^([0-9a-fA-F][0-9a-fA-F][:-]){5}[0-9a-fA-F]{2}$',
            message: 'Mac주소에 맞는 형식으로 입력해주세요.',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    /**
     * 관리대상 정보 객체
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    objInfo() {
      return {
        label: this.objectInfo.objName,
        obj: this.objectInfo,
      };
    },
    /**
     * 구성정보 더보기 이전 표현 객체
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    configInfo() {
      let config = [{ key: '', label: '' }];
      config = RELATIONSHIP_INFO.CONFIG_INFO[this.objectType] || [];
      return config;
    },
    showEditBtn() {
      const managerType = isEmpty(this.getUserInfo) ? false : this.getUserInfo.managerType;
      return !this.isObj && (managerType !== 'ADMIN');
    },
    currentMapId() {
      return this.$store.getters.getCurrentMapId;
    },
  },
  mounted() {
    if (this.objectType === 'DEVICE') {
      this.objtype = [];
      MapAPI.getVirtualObjectTree().then((response) => {
        if (response.data.success) {
          const result = filter(response.data.children, (item) => (item.itemId === 'NMS'));
          result.forEach((item) => {
            item.children.forEach((child) => {
              delete child.children;
            });
          });
          this.objtypeList = result;
        }
      });
    }
  },
  methods: {
    /**
      * 데이터 초기화(요청데이터)
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} configInfoData [description]
     */
    setData(configInfoData) {
      if (!isEmpty(configInfoData)) {
        this.objtype = [];
        this.originConfigInfoData = cloneDeep(configInfoData);
        this.configInfoData = configInfoData;
        this.objtype.push('NMS');
        this.objtype.push(configInfoData.objtypeId);
      }
    },
    /**
     * 데이터 초기화(기본값)
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    initData() {
      this.configInfoData = {};
      this.activeTab = 'basic';
      if (this.$refs.collapse) {
        this.$refs.collapse.setActiveNames([]);
      }
    },
    onEditBtnClick() {
      this.editable = !this.editable;
    },
    onSaveBtnClick() {
      const canvas = MapInfo.getInstance(this).getCanvas();
      this.$refs.configForm.validate((valid) => {
        if (valid) {
          this.$confirm(...msgUtil.getBasicConfirmData('구성정보를 수정'))
            .then(() => {
              let submitData = {};
              if (this.objectType === 'DEVICE') {
                submitData = {
                  ipaddress: this.configInfoData.deviceIp,
                  objtypeId: this.configInfoData.objtypeId,
                  deviceName: this.configInfoData.deviceName,
                  macAddress: this.configInfoData.deviceMac,
                  companyName: this.configInfoData.deviceCompanyName,
                  deviceDesc: this.configInfoData.deviceDesc,
                };
                MapAPI.updateAutomapDeviceConfigInfo(submitData).then((response) => {
                  const result = response.data;
                  if (result.success) {
                    this.$message.success('구성정보를 수정하였습니다.');
                    if (canvas) {
                      canvas.refreshMap(this.currentMapId);
                    }
                  } else {
                    this.configInfoData = cloneDeep(this.originConfigInfoData);
                    this.$message.error('구성정보를 수정하지 못하였습니다.');
                  }
                });
              } else {
                submitData = {
                  ipaddress: this.configInfoData.deviceIp,
                  ifIndex: this.objectInfo.ifIndex,
                  ifMacaddress: this.configInfoData.interfaceMac,
                  deviceName: this.configInfoData.deviceName,
                };
                submitData[this.configInfoData.interfaceNameTypeKey] = this.configInfoData.interfaceName;
                MapAPI.updateAutomapInterfaceConfigInfo(submitData).then((response) => {
                  const result = response.data;
                  if (result.success) {
                    this.$message.success('구성정보를 수정하였습니다.');
                    if (canvas) {
                      canvas.refreshMap(this.currentMapId);
                    }
                  } else {
                    this.configInfoData = cloneDeep(this.originConfigInfoData);
                    this.$message.error('구성정보를 수정하지 못하였습니다.');
                  }
                });
              }
              this.editable = !this.editable;
            })
            .catch(() => {
              this.configInfoData = cloneDeep(this.originConfigInfoData);
            });
        }
      });
    },
    onUndoBtnClick() {
      this.configInfoData = cloneDeep(this.originConfigInfoData);
      this.editable = !this.editable;
    },
    /**
     * 포매터 속은 key값에 따른 값 변환 함수
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} value     [description]
     * @param  {[type]} key       [description]
     * @param  {[type]} formatter [description]
     * @param  {[type]} unit      [description]
     * @param  {[type]} unitText  [description]
     * @return {[type]}           [description]
     */
    convertValue(value, key, formatter, unit, unitText) {
      // formatter 처리
      if (formatter === 'value') {
        let result = '';
        if (isEmpty(unit) && isEmpty(unitText)) {
          result = `${convertValuByUnit(value, '', true, null, true)}`;
        } else {
          result = `${convertValuByUnit(value, unit, true, false, true)}${isEmpty(unitText) ? '' : unitText}`;
        }
        return result;
      } else if (formatter === 'count') {
        return `${isNil(value) ? 0 : value}개`;
      } else if (formatter === 'day') {
        return `${value}일`;
      } else if (formatter === 'datetime') {
        return value ? getDateToString(value) : '-';
      }

      return getValueAfterCheckEmpty(value);
    },
    onObjtypeChange() {
      const checkedNode = this.$refs.objtypeCascader[0].getCheckedNodes()[0];
      this.configInfoData.deviceTypeName = checkedNode.label;
      this.configInfoData.objtypeId = checkedNode.value;
    },
  },
};
</script>

<style lang="scss">
.list-value,
.el-form-item__content {
 .editable {
   .el-input__inner {
     height: 20px;
     line-height: 12px;
   }
 }
}
.automap-object {
  .config-info {
    .el-cascader--mini {
      line-height: 20px;

      .el-input--mini .el-input__inner {
        height: 20px;
      }
      .el-input__suffix {
        right: -2px;
        top: -6px;
      }
    }
  }
}
.automap-objtype-cascader {
  .el-cascader-panel {
    font-size: 12px;
    .el-cascader-menu {
      min-width: 140px;
    }
    .el-cascader-node.is-active,
    .el-cascader-node.in-active-path {
      color: #2b68be !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/major-info/AutomapObjectConfigInfoView.vue